module.exports = __webpack_public_path__ + "img/amwins_logo--digital.9c89d89d.svg";